import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=b8159ea6&scoped=true&"
import script from "./Activation.vue?vue&type=script&lang=js&"
export * from "./Activation.vue?vue&type=script&lang=js&"
import style0 from "./Activation.vue?vue&type=style&index=0&id=b8159ea6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8159ea6",
  null
  
)

export default component.exports